export default __webpack_public_path__ + "static/media/logo-ir.a25ed328.svg";